<template>
  <div class="performanceStatistics">
    <div>
      <el-form :inline="true">
        <el-form-item>
          <el-select v-model="form.agent" placeholder="请选择代理">
            <el-option
              v-for="item in form.agentData"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small">当天</el-button>
          <el-button type="primary" size="small">本周</el-button>
          <el-button type="primary" size="small">本月</el-button>
          <el-button type="primary" size="small">最近三个月</el-button>
          <el-button type="primary" size="small">最近半年</el-button>
          <el-button type="primary" size="small">{{$t('common.search')}}</el-button>
          <el-button type="primary" size="small">{{$t('common.export')}}</el-button>
        </el-form-item>
      </el-form>
      <div class="table">
        <span class="table-title">当前代理</span>
        <el-table :data="currentTableData" style="width: 100%" border>
          <el-table-column :prop="item.id" :label="item.name" v-for="item in currentTableNav"></el-table-column>
        </el-table>
      </div>
      <div class="table">
        <span class="table-title">下线代理</span>
        <el-table :data="nextTableData" style="width: 100%" border>
          <el-table-column :prop="item.id" :label="item.name" v-for="item in nextTableNav"></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'incomeStatistics',
    data() {
      return {
        form: {
          agent: '',
          agentData: [],
          startTime: new Date(),
          endTime: new Date()
        },
        currentTableNav: [
          { name: '代理代号', id: 'agentCode' },
          { name: '代理名称', id: 'agentName' },
          { name: '总开户量', id: 'startTime' },
          { name: '总激活量', id: 'endTime' },
          { name: '直客开户量', id: 'assignTradeAmount' },
          { name: '直客激活量', id: 'assignLevelAmount' },
          { name: '交易总金额', id: 'assignLevelAmount' },
          { name: '直客交易总金额', id: 'assignLevelAmount' },
        ],
        currentTableData: [],
        nextTableNav: [
          { name: '代理代号', id: 'agentCode' },
          { name: '代理名称', id: 'agentName' },
          { name: '总开户量', id: 'startTime' },
          { name: '总激活量', id: 'endTime' },
          { name: '直客开户量', id: 'assignTradeAmount' },
          { name: '直客激活量', id: 'assignLevelAmount' },
          { name: '交易总金额', id: 'assignLevelAmount' },
          { name: '直客交易总金额', id: 'assignLevelAmount' },
        ],
        nextTableData: []
      }
    }
  }
</script>

<style lang="scss" scoped>
  .performanceStatistics {
    margin: 20px;
    .table{
      margin-bottom: 30px;
      .table-title{
        overflow: hidden;
        display: block;
        font-size: 16px;
        margin-bottom: 10px;
        font-weight: bolder;
      }
    }
  }
</style>
